import { render, staticRenderFns } from "./LawLeft.vue?vue&type=template&id=e895ff12&scoped=true&"
import script from "./LawLeft.vue?vue&type=script&lang=js&"
export * from "./LawLeft.vue?vue&type=script&lang=js&"
import style0 from "./LawLeft.vue?vue&type=style&index=0&id=e895ff12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895ff12",
  null
  
)

export default component.exports